export default `Region,Population
Azad Jammu and Kashmir,4045366
Balochistan,12344408
Gilgit-Baltistan,1249000
Islamabad Capital Territory,2006572
Khyber Pakhtunkhwa,35525047
Punjab,110012442
Sindh,47886051
Pakistan,214261409`